import axios from "axios";
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from "../../../Notifications/ToastifyActions";

function RefreshStoreOrdersService(token, profileId) {
  return axios
    .post(
      `${CURRENT_API_URL}/sellerPartner/api/store-orders/${profileId}/refresh/`,
      {},
      {
        headers: { Authorization: token },
      }
    )
    .then((res) => res.data)
    .catch((error) => {
      const detail =
        (error.response && error.response.data && error.response.data.detail) ||
        "An error occurred while starting order sync.";
      notify.NotifyError(detail);
      throw new Error(detail);
    });
}

export default RefreshStoreOrdersService;
